export default {
  title: '线索管理',
  search: {
    companyName: '公司名称',
    companyNamePlaceholder: '请输入公司名称',
    contactPerson: '联系人',
    contactPersonPlaceholder: '请输入联系人',
    source: '来源',
    sourcePlaceholder: '请选择来源',
    status: '状态',
    statusPlaceholder: '请选择状态',
    searchBtn: '搜索',
    resetBtn: '重置'
  },
  table: {
    columns: {
      companyName: '公司名称',
      contactPerson: '联系人',
      phone: '电话',
      email: '邮箱',
      source: '来源',
      status: '状态',
      dateCreated: '提交时间',
      latestFollowTime: '最新跟进时间',
      followBy: '跟进人',
      actions: '操作'
    },
    actions: {
      view: '查看',
      followUp: '跟进',
      delete: '删除'
    }
  },
  dialogs: {
    viewTitle: '线索详情',
    followUpTitle: '跟进线索',
    deleteTitle: '确认删除',
    deleteContent: '确定要删除这条线索吗？',
    deleteRestoreWarn: '删除后无法恢复，是否确认删除？',
    followRecord: '跟进记录',
    followRecordPlaceholder: '请详细描述本次跟进情况...',
    followRecordRequired: '请填写跟进记录'
  },
  messages: {
    fetchFailed: '获取数据失败，请重试',
    searchSuccess: '搜索完成',
    searchFailed: '搜索失败，请重试',
    resetInfo: '搜索条件已重置',
    exportSuccess: '导出成功',
    exportFailed: '导出失败，请重试',
    followSuccess: '已跟进线索: {name}',
    followFailed: '跟进失败，请重试',
    deleteSuccess: '已删除线索: {name}',
    deleteFailed: '删除失败，请重试'
  },
  sources: {
    home: '首页留资',
    ai: 'AI导入'
  },
  status: {
    pending: '未跟进',
    followed: '已跟进'
  }
}
